import { memo } from 'react';
import { useParams } from 'react-router-dom';

import useHasPermission from '@/utils/authentication/use-has-permission';
import { GENERAL_EDITABLE_PERMISSIONS } from '@/types/permissions.types';
import EditStateTextArea from '@ui/edit-state-wrapper/edit-state-text-area';

type EditDescriptionProps = {
  defaultValue?: string;
  onBlur?: (value: string) => void;
  disabled?: boolean;
  maxRowsFocused?: number;
  maxRowsBlurred?: number;
};

const EditDescription = memo(
  ({ defaultValue, disabled, onBlur, maxRowsFocused = 4, maxRowsBlurred = 2 }: EditDescriptionProps) => {
    const params = useParams();
    const language = params?.language || 'en';

    const { hasPermission: hasPermissions } = useHasPermission({
      allowedRoles: GENERAL_EDITABLE_PERMISSIONS,
    });

    const handleBlur = (value: string) => {
      if (disabled || !hasPermissions) {
        return;
      }
      onBlur?.(value.trim());
    };

    return (
      <div data-component="EditDescription">
        <EditStateTextArea
          key={language}
          Label="STORYLINE"
          maxRowsFocused={maxRowsFocused}
          maxRowsBlurred={maxRowsBlurred}
          disabled={disabled || !hasPermissions}
          textAreaProps={{
            placeholder: 'Add storyline',
            defaultValue,
            disabled: disabled || !hasPermissions,
          }}
          onBlur={handleBlur}
        />
      </div>
    );
  }
);

export default EditDescription;
